import { React } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import './Events.scss';

export default function Events() {
  return (
    <div className="events-container">
      <h1 className="site_main_header">Events</h1>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 3000 }}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        <SwiperSlide>
          <div className="events-card">
            <div className="events-image">
              <img src="https://i.imgur.com/xLNxgGP.png" alt="South Florida Code Camp" />
            </div>
            <div className="events-content">
              <h2>South Florida Code Camp</h2>
              <p>
                South Florida Code Camp is a free, one day learning event for programming, databases, and other development technologies, web application development, and understanding how to craft leading-edge web applications, distributed services, and the latest techniques in web-based solutions.
              </p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="events-card">
            <div className="events-image">
              <img src="https://i.imgur.com/NxVRcxH.png" alt="ITPalooza Event" />
            </div>
            <div className="events-content">
              <h2>ITPalooza</h2>
              <p>
                ITPalooza brings the South Florida technology community together for a remarkable one-day event that delivers a fusion of education, networking, interactivity, and fun. Join local tech organizations and tech professionals for a dynamic annual event.
              </p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="events-card">
            <div className="events-image">
              <img src="https://i.imgur.com/U0XeTFu.png" alt="eMerge Americas Event" />
            </div>
            <div className="events-content">
              <h2>eMerge Americas</h2>
              <p>
                eMerge Americas is a premier technology event connecting the Americas. This annual event showcases the latest technological innovations and connects global industry leaders and investors with entrepreneurs.
              </p>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
